module.exports = __webpack_public_path__ + "img/Disposal(Button).dd90039f.svg";